import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function publish(id, authHeaders) {
    const response = await fetch(`${API_URL}/p/itinerary/publish`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ id })
    });
    return await response.json();
}

async function removePublication(id, authHeaders) {
    const response = await fetch(`${API_URL}/p/itinerary/publish`, {
        method: 'DELETE',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ id })
    });
    return await response.json();
}

export function usePublishQuery(options) {
    return useAuthMutation({
        mutationFn: publish,
        ...options
    });
}

export function useRemovePublication(options) {
    return useAuthMutation({
        mutationFn: removePublication,
        ...options
    });
}
